export default "__VITE_ASSET__BAb6dtlE__"